module.exports = __webpack_public_path__ + "8c7b5ecfde5f9fa036d0877dea63495e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/hawaiian-beach-hut-empty.png
// module id = 309
// module chunks = 0